import styled from 'styled-components';
import { Modal } from 'antd';

export const StyledModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 12px;
    overflow: hidden;
  }

  .ant-modal-header {
    background: #ffffff !important;
    border-bottom: 1px solid #f0f0f0;
    padding: 16px 24px;
  }

  .ant-modal-title {
    color: #262626;
    font-size: 16px;
    font-weight: 600;
  }

  .ant-modal-body {
    padding: 0;
  }
`;

export const ModalContent = styled.div`
  padding: 32px 32px 24px;
  text-align: center;
`;

export const IconsSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
`;

export const AppIconWrapper = styled.div`
  width: 52px;
  height: 52px;
  border-radius: 12px;
  background: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  flex-shrink: 0;

  img {
    width: 40px;
    height: 40px;
    object-fit: contain;
  }
`;

export const DashedLine = styled.div`
  width: 28px;
  border-top: 2px dashed #d9d9d9;
  flex-shrink: 0;
`;

export const WarningDot = styled.div`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #fff2f0;
  border: 1px solid #ffccc7;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const PrimaryMessage = styled.p`
  font-size: 14px;
  font-weight: 600;
  color: #262626;
  margin: 0 0 10px;
  line-height: 1.5;
`;

export const SecondaryMessage = styled.p`
  font-size: 14px;
  color: #8c8c8c;
  margin: 0 0 20px;
  line-height: 1.6;
`;

export const EmailBadge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #f5f5f5;
  border: 1px solid #e8e8e8;
  border-radius: 20px;
  padding: 5px 14px;
  font-size: 13px;
  color: #262626;
  margin-bottom: 28px;

  span {
    font-weight: 700;
    color: #262626;
  }
`;

export const ModalFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 24px;
  border-top: 1px solid #f0f0f0;

  .ant-btn-primary {
    background-color: var(--Primary-primary, #3547C8);
    border-color: var(--Primary-primary, #3547C8);
    border-radius: 8px;
    height: 38px;
    padding: 0 18px;
    font-weight: 500;
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }

  .ant-btn-default {
    border-radius: 8px;
    height: 38px;
    padding: 0 16px;
    font-weight: 500;
    color: #595959;
  }
`;
